import { render } from "./whatsAppDialog.vue?vue&type=template&id=174174cd&scoped=true"
import script from "./whatsAppDialog.vue?vue&type=script&lang=js"
export * from "./whatsAppDialog.vue?vue&type=script&lang=js"

import "./whatsAppDialog.vue?vue&type=style&index=0&id=174174cd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174174cd"]])

export default __exports__